<template>
  <!-- eslint-disable -->
  <div class="content">
    <div v-if="!notifg">
      <div class="content_tow">
        <div class="tow_title">
          <div class="title_chu">
            <img src="../../assets/img/生产数据.png">
          </div>
          <div class="title_top">
            <div>厨师生产数据</div>
            <!-- <div style="border: 1px solid #C2986E;border-radius: 12px;font-size: 12px;display: flex;
        justify-content: center;align-items: center;width: 93px;color: #C2986E;" @click="Excle()">导出Excel
                <img style="width: 12px;height: 12px;" src="../../assets/前往.png">
            </div> -->
          </div>
        </div>
        <div class="tow_content">
          <div class="tow_one">
            <div class="one_title">
              <div class="isnum-1">总份数</div>
              <div class="isnum-2">{{ chefData.sumqty }}</div>
            </div>
            <div class="title_fgx"></div>
            <div class="one_title">
              <div class="isnum-1">总金额</div>
              <div class="isnum-2">{{ chefData.sumamount }}元</div>
            </div>
          </div>
          <div class="tow_tow" v-for="(itme, index) in arr" :key="index" v-if="index < Ifgnum">
            <div class="tow_content_title">
              <div>
                <img style="width: 4px;height: 16px;" src="../../assets/Rectangle 712113.png">
                <div style="margin-left: 8px;">{{ itme.name }}</div>
              </div>
              <div>
                <div style="margin-right: 5px;font-size: 14px;color: #999999;" @click="xq(itme)">详情
                </div>
                <img style="width: 16px;height: 16px;" src="../../assets/前往 (1).png">
              </div>
            </div>
            <div class="tow_content_title">
              <div>
                <div>生产份数: {{ itme.num }}</div>
              </div>
              <div>
                <div>生产金额: {{ itme.money }}元</div>
              </div>
            </div>
            <div class="tow_contents">
              <div class="tow_contents_left">
                <div class="left_top">
                  <div class="isnum-1">平均制作时长</div>
                  <div class="isnum-2">{{ itme.date }}</div>
                </div>
                <div class="left_top">
                  <div class="isnum-1">制菜占比</div>
                  <div class="isnum-2">{{ itme.bfb }}</div>
                </div>
              </div>
              <div class="tow_contents_right">
                <div class="right_top" @click="showIfgData(0, itme)">
                  <div class="isnum-1" style="margin-left: 8px;">超时</div>
                  <div style="display: flex;align-items: center;margin-right: 8px;">
                    <div class="isdata-1">{{ itme.timeoutnum }}</div>
                    <img style="width: 16px;height: 16px;margin-left: 6px;"
                         src="../../assets/img/Group 2394.png" alt="">
                  </div>

                </div>
                <div class="right_top" @click="showIfgData(1, itme)">
                  <div style="font-size: 14px;color: #666666;margin-left: 8px;">沽清</div>
                  <div style="display: flex;align-items: center;margin-right: 8px;">
                    <div class="isdata-1" style="color: rgb(194, 152, 110);">{{ itme.estimateqty }}
                    </div>
                    <img style="width: 16px;height: 16px;margin-left: 6px;"
                         src="../../assets/img/Group 2394.png" alt="">
                  </div>

                </div>
                <div class="right_top" @click="showIfgData(2, itme)">
                  <div style="font-size: 14px;color: #666666;margin-left: 8px;">退菜</div>
                  <div style="display: flex;align-items: center;margin-right: 8px;">
                    <div class="isdata-1">{{ itme.refundqty }}</div>
                    <img style="width: 16px;height: 16px;margin-left: 6px;"
                         src="../../assets/img/Group 2394.png" alt="">
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div style="display: flex;justify-content: center;margin-top: 20px;" @click='zhangkai'
               v-if="Ifgnum == 5 && arr.length > 5">
            <img src="../../assets/Group 2943.png" style="width: 64px;height: 20px;">
          </div>
          <div style="display: flex;justify-content: center;margin-top: 20px;" @click="shuifan"
               v-if="Ifgnum !== 5">
            <img src="../../assets/Group 2943 (1).png" style="width: 64px;height: 20px;">
          </div>
        </div>
      </div>
      <div class="content_tow">
        <div class="tow_title">
          <div class="title_chu">
            <img src="../../assets/img/活动分析.png">
          </div>
          <div class="title_top">
            <div>生产趋势图</div>
          </div>
        </div>
        <div class="three_content">
          <div v-if="this.chefData.producetrendInfor !== undefined">
            <!-- 的 -->
            <div id='mainss' style="min-height: 200px;overflow: scroll;"
                 v-if="this.chefData.producetrendInfor.length !== 0">
            </div>
          </div>
        </div>
      </div>
      <div class="opne">
        <van-popup v-model="Storeshow" closeable @click-close-icon="showIfg" @click-overlay="showIfg">
          <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;"
               v-if="showIndex == 0">
            <div class="istalise">超时详情</div>
            <div style="margin-top: 10px;" class="fxid"></div>
            <div style="padding: 12px; max-height: 250px; overflow: scroll;">
              <div style="font-size: 14px;" v-for="(itme, index) in TimeOutData">

                <div style="display: flex;justify-content: space-between;">
                  <div class="let-txt-1">{{ itme.productname }}</div>
                  <div class="let-txt-1">桌台：{{ itme.dintablename }}</div>
                </div>
                <div style="font-size: 12px;color: #666666;">
                  <div class="let-txt-2">超时时间：{{ itme.timeout }}分钟</div>
                  <div class="let-txt-2">起菜时间：{{ itme.createtime }}</div>
                </div>
                <div style="margin:12px 0px;" class="fxid" v-if="index !== TimeOutData.length - 1">
                </div>
              </div>


            </div>
            <div style="margin:12px 0px;" class="fxid"></div>
            <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
              <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
                <div style="font-size: 16px;color: #ffffff;" @click="showIfg">关闭</div>
              </div>
            </div>
          </div>
          <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;"
               v-else-if="showIndex == 1">
            <div class="istalise">沽清详情</div>
            <div style="border: 1px solid #EEEEEE;margin-top: 10px;" class="fxid"></div>
            <div style="padding: 12px; max-height: 250px; overflow: scroll;">
              <div style="font-size: 14px;" v-for="itme in 2">

                <div style="display: flex;justify-content: space-between;">
                  <div class="let-txt-1">祖传粉蒸肉</div>
                  <div style="display: flex;font-size: 12px;">
                    <div class="let-txt-3">限购：100</div>
                    <div class="let-txt-3" style="margin-left: 10px;">销售：100</div>
                  </div>
                </div>
                <div style="font-size: 12px;color: #666666;">
                  <div class="let-txt-2">限购时间：2024-03-06 12:56:09</div>
                  <div class="let-txt-2">沽清时间：2024-03-06 12:02:56</div>
                </div>
                <div style="border: 1px solid #EEEEEE;margin:12px 0px;" class="fxid" v-if="itme !== 2">
                </div>
              </div>


            </div>
            <div style="border: 1px solid #EEEEEE;margin:12px 0px; " class="fxid"></div>
            <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
              <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
                <div style="font-size: 16px;color: #ffffff;" @click="showIfg">关闭</div>
              </div>
            </div>
          </div>
          <div style="margin-top: 15px;min-height: 150px; max-height: 425px; overflow: hidden;"
               v-else-if="showIndex == 2">
            <div class="istalise">退菜详情</div>
            <div style="border: 1px solid #EEEEEE;margin-top: 10px;" class="fxid"></div>
            <div style="padding: 12px; max-height: 250px; overflow: scroll;">
              <div style="font-size: 14px;" v-for="(itme, index) in findOut">

                <div style="display: flex;justify-content: space-between;">
                  <div class="let-txt-1">{{ itme.productname }}</div>
                  <div class="let-txt-1">桌台：{{ itme.dintablename }}</div>
                </div>
                <div style="font-size: 12px;color: #666666;">
                  <div class="let-txt-2">退菜时间：{{ itme.refundtime }}</div>
                  <div class="let-txt-2">退菜金额：￥{{ itme.refundamount }}</div>
                  <div class="let-txt-2">退菜原因：{{ itme.refundreason }}</div>
                </div>
                <div style="border: 1px solid #EEEEEE;margin:12px 0px;" class="fxid"
                     v-if="index !== findOut.length - 1">
                </div>
              </div>


            </div>
            <div style="border: 1px solid #EEEEEE;margin:12px 0px;" class="fxid"></div>
            <div style="display: flex;justify-content: center;align-items: center;padding-bottom: 10px;">
              <div style="width: 80px;height: 32px;border-radius: 6px;background-color: #C2986E;
                display: flex;justify-content: center;align-items: center;text-align: center;">
                <div style="font-size: 16px;color: #ffffff;" @click="showIfg">关闭</div>
              </div>
            </div>
          </div>
        </van-popup>
      </div>
    </div>
    <not :width="widths" v-if="notifg"/>
    <loading style="z-index: 10000000;" v-if="loadingIFg"></loading>

  </div>
</template>

<script>
// import 'swiper/css/swiper.css'
// import moment from "moment";
// import "moment/locale/zh-cn";
import * as XLSX from 'xlsx'
import * as echarts from 'echarts';
import {unZip} from '../../utils/ZIP/index.js';
import loading from '../../components/loading/index.vue'
import not from '@/components/not/index.vue';
import moment from 'moment';

export default {
  data() {
    return {
      widths: 0,
      showIndex: 0,
      Ifgnum: 5,
      loadingIFg: true,
      notifg: false,
      show: false,
      Storeshow: false, //弹窗
      arr: [],
      TimeOutData: [],
      Storeshow: false, //弹窗
      echarts: {},
      chefData: {},
      dateArr: [],
      EchartsX: [],
      EchartsY: [],
      chefId: 0,
      findOut: [],
      seltype: 0,
    }
  },
  methods: {
    zhangkai() {
      this.Ifgnum = this.arr.length
    },
    shuifan() {
      this.Ifgnum = 5
    },
    showIfg(e, data) {
      this.Storeshow = false
      // if (e == 0) {
      //     this.$store.commit("SetshowData", data.timeOut)
      // } else if (e == 1) {
      //     this.$store.commit("SetshowData", data.GuQian)
      // } else if (e == 2) {
      //     this.$store.commit("SetshowData", data.Outdish)
      // }
    },
    showIfgData(e, data) {

      this.showIndex = e
      this.chefId = data.personid
      if (e == 0 && data.timeoutnum !== 0) {
        this.Storeshow = true
        this.Timeout()
      } else if (e == 2 && data.refundqty !== 0) {
        this.Storeshow = true
        this.fundinfo()
      }

    },
    async Timeout() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
        personid: this.chefId
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetPersonProduceTimeoutInfor`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      this.TimeOutData = dataOne
      console.log(this.TimeOutData);
      this.TimeOutData = this.TimeOutData.filter(e => {
        return e.timeout !== 0
      })
    },
    async fundinfo() {
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
        personid: this.chefId
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetPersonProduceRefundInfor`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      this.findOut = dataOne
    },
    Excle() {
      const headers = ['厨师名称', '菜品名称', '菜品分类（小程序菜单）', '桌台', '起菜时间（立即上菜/叫起）', '完成时间', '制作时长',]
      const tableData = [
        {name: '李木子', age: '煎豆腐', dh: '豆腐', z: 'A1005', time: '12:20', stime: '12:25', jTime: '5分钟'},
        {name: '李四', age: '辣鸡豆腐', dh: '豆腐', z: 'A1005', time: '11:20', stime: '11:25', jTime: '5分钟'},
        {name: '张三', age: '火腿肠', dh: '豆腐', z: 'A1005', time: '16:20', stime: '16:25', jTime: '5分钟'},
        {name: '李木子', age: '蛋炒饭', dh: '豆腐', z: 'A1005', time: '18:20', stime: '18:25', jTime: '5分钟'},
        {name: '欧阳', age: '鱼', dh: '豆腐', z: 'A1005', time: '19:20', stime: '19:25', jTime: '5分钟'},
      ]
      const data = tableData.map(item => [item.name, item.age, item.dh, item.z, item.time, item.stime, item.jTime])
      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
      XLSX.writeFile(workbook, '厨师生产数据.xlsx')
    },
    SetEcharts() {
      // console.log(document.getElementById('mainss'));
      if (this.chefData.producetrendInfor.length <= 0) {
        return
      }
      var chartDom = document.getElementById('mainss');
      var myChart = echarts.init(chartDom);
      var option;
      let widths = this.EchartsX.length * 50
      if (widths <= myChart.getWidth()) {
        widths = myChart.getWidth()
      }
      myChart.resize({
        width: widths,
        // height: 300
      })
      option = {
        xAxis: {
          // type: 'time',
          // splitNumber: 20,
          data: this.EchartsX
        },
        // dataZoom: [{
        //     type: 'slider', // 设置为滑动条型式
        //     show: true, // 显示dataZoom组件
        //     start: 0, // 默认显示的起始位置为0
        //     end: 30, // 默认显示的结束位置为100
        //     handleSize: 8, // 滑动条的手柄大小
        //     // fillerColor: '#F6CA00',
        //     // handleStyle: {
        //     //     color: '#F6CA00' // 滑动条的手柄颜色
        //     // },
        //     xAxisIndex: [0], // 表示控制第一个x轴
        //     filterMode: 'filter' // 设置为filter模式，即数据超过范围时会被过滤掉
        // }],
        yAxis: {
          type: 'value'
        },
        grid: {
          top: '30px',
          left: '40px',
          bottom: '30px',
          right: '30px'
        },
        series: [
          {
            data: this.EchartsY,
            type: 'line',
            itemStyle: {

              normal: {
                label: {
                  show: true // 在折线拐点上显示数据
                },
                color: "#F6CA00",
              }
            },
            lineStyle: {
              color: '#F6CA00'
            }
          }
        ]
      };

      option && myChart.setOption(option);
    },
    xq(itme) {
      if (itme.num <= 0) {
        return
      }
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
        personid: itme.personid
      }
      this.$router.push({
        path: '/chefSort',
        query: {
          name: itme.name,
          axiosData: JSON.stringify(PostData)
        }
      })
    },
    async getChefData() {
      if (this.$route.query.DateArr == null || this.$route.query.DateArr == undefined || this.$route.query.seltype == undefined) {
        return
      }
      this.dateArr = this.$route.query.DateArr
      this.StoresId = this.$route.query.StoresId
      this.seltype = this.$route.query.seltype
      let PostData = {
        beginDate: this.dateArr[0],
        endDate: this.dateArr[1],
        storeid: this.StoresId,
        seltype: this.seltype
      }
      let {ReturnTag} = await this.$server.post(`/WeCom/GetPersonProduceReportData`, PostData)
      let datas = unZip(ReturnTag)
      console.log(JSON.parse(datas));
      let dataOne = JSON.parse(datas)
      if (dataOne.sumqty == 0) {
        this.notifg = true
        return
      }
      this.chefData = dataOne
      this.arr = []
      this.chefData.personInfor.forEach(e => {
        e.name = e.personname
        e.num = e.producenum
        e.money = e.produceamount
        e.date = e.avgtime
        e.bfb = e.produceratio
      });

      this.arr = this.chefData.personInfor
      this.arr.reverse()
      // console.log(this.arr);
      console.log(this.chefData.producetrendInfor);
      this.EchartsX = []
      this.EchartsY = []

      this.chefData.producetrendInfor.forEach(e => {
        this.EchartsX.push(e.XString)
        let dates = null
        // console.log();
        // if(this.$route.query.seltype==0){
        //     dates=this.$route.query.DateArr[0] + ' ' + e.XString
        // }else{

        // }
        this.EchartsY.push(e.Ydecimal)
        // this.EchartsY.push({
        //     value: [
        //         dates,
        //         e.Ydecimal]
        // })
      })
      // this.EchartsY[7].value[0] = this.$route.query.DateArr[0] + ' ' + "13:45"
      console.log(this.EchartsX, this.EchartsY);
      setTimeout(() => {
        this.SetEcharts()
      }, 500)

    }
  },
  async mounted() {
    this.loadingIFg = true
    await this.getChefData()
    await setTimeout(async () => {
      this.loadingIFg = false
    }, 1000)

  },
  components: {
    not,
    loading
  }

}
</script>

<style lang="scss" scoped>
@import '../../assets/hotcss/hotcss-master/src/px2rem.scss';

// 新增样式
.isnum-1 {
  color: rgb(102, 102, 102);
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
}

.isnum-2 {
  color: rgb(51, 51, 51);
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 8px;
}

.isdata-1 {
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: right;
  color: rgb(227, 15, 15);
}

.istalise {
  color: rgb(51, 51, 51);
  font-family: '思源黑体 CN';
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
}

.let-txt-1 {
  color: rgb(51, 51, 51);
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0%;
  text-align: left;
}

.let-txt-2 {
  color: rgb(102, 102, 102);
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 12px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0%;
  text-align: left;
  margin-top: 10px;
}

.let-txt-3 {
  color: rgb(51, 51, 51);
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0%;
  text-align: right;
}


.content {
  width: calc(100% - 20px);
  background-color: #f5f5f5;
  padding: 10px;
}

.fxid {
  box-sizing: border-box;
  border: 1px solid rgb(238, 238, 238);
  background: rgb(255, 255, 255);
}

.opne .van-popup {
  width: 90%;
}

.content_tow {
  border-radius: 10px;
  background: rgb(255, 255, 255);
  border-radius: px2rem(25);
  margin-top: px2rem(20);

  .fengjiexiao {
    width: 100%;
    border: px2rem(1) dashed #DDDDDD;
    margin-top: px2rem(12) !important;
    margin-bottom: px2rem(12) !important;
  }

  .tow_title {
    display: flex;
    align-items: center;
    flex-direction: row;
    padding: px2rem(20);
    background: linear-gradient(90deg, #F9E6CA 0.88%, rgba(255, 251, 246, 0.00) 99.94%);
    border-top-right-radius: px2rem(25);
    border-top-left-radius: px2rem(25);

    .title_chu {
      width: 16px;
      height: 16px;
      margin-right: px2rem(10);

      img {
        width: 100%;
        height: 100%;
      }
    }

    .title_top {
      display: flex;
      flex: 1;
      justify-content: space-between;

      div {
        color: #333;
        font-family: Alibaba;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;

        /* 100% */

      }

      .top_red {
        color: #E30F0F;
        font-family: Alibaba PuHuiTi;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        /* 100% */
      }
    }

    div {
      color: #333;
      font-family: Alibaba PuHuiTi;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      /* 100% */
    }
  }

  .tow_content {
    box-sizing: border-box;
    padding: px2rem(20);
    border-radius: 10px;
    background: rgb(255, 255, 255);

    .tow_one {
      background-color: #F8F8F8;
      height: 62px;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      border-radius: 5px;
      background: rgb(248, 248, 248);

      .title_fgx {
        border: px2rem(1) dashed #DDDDDD;
        height: 60%;
      }

      .one_title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    .tow_tow {
      margin-top: 20px;

      .tow_content_title {
        margin-top: 13px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: rgb(51, 51, 51);
        font-family: 'Alibaba PuHuiTi 3.0';
        font-size: 16px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0px;
        text-align: left;

        div {
          display: flex;
          align-items: center;
          color: rgb(51, 51, 51);
          font-family: 'Alibaba PuHuiTi 3.0';
          font-size: 16px;
          font-weight: 500;
          line-height: 16px;
          letter-spacing: 0px;
          text-align: left;
        }
      }
    }

    .tow_contents {
      display: flex;
      margin-top: 12px;

      .tow_contents_left {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .left_top {
          width: 100%;
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #F8F8F8;
          border-radius: 5px;
          margin-top: 6px;

          div {
            display: flex;

            justify-content: center;
            align-items: center;
          }
        }
      }

      .tow_contents_right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .right_top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: 1;
          width: 100%;
          // padding-top: 12px;
          // padding-bottom: 12px;
          // padding-left: 4px;
          // padding-right: 4px;
          background-color: #F8F8F8;
          border-radius: 4px;
          margin-top: 6px;
          margin-left: 12px;

        }
      }
    }
  }

}

.three_content {
  padding: 10px;
}

.content_tow .tow_title .title_top div {
  color: rgb(51, 51, 51);
  font-family: 'Alibaba PuHuiTi 3.0';
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
}

.van-popup--center {
  border-radius: 8px;
  background: rgb(255, 255, 255);
}

.van-popup__close-icon--top-right {
  top: 10px !important;
}

.van-popup__close-icon {
  top: 10px !important;
}
</style>
<style></style>